export const EvidenceNameSchema = {
  id: 2,
  name: "Text Input",
  type: "text",
  title: "Name",
  required: true,
  placeholder: "Enter the name",
  char_limit: "",
};

export const EvidenceDescriptionSchema = {
  id: 3,
  name: "Text Area",
  type: "textarea",
  title: "Description",
  placeholder: "Enter the description",
  required: false,
  char_limit: "",
};

export const EvidenceCategorySchema = {
  id: 4,
  name: "Text Input",
  type: "text",
  title: "Category",
  required: true,
  placeholder: "Category will be auto-filled",
  char_limit: "",
  readOnly: true,
};

export const MetricSelectionSchema = {
  id: 5,
  name: "Select",
  type: "select",
  title: "Related Metric",
  required: false,
  placeholder: "Select a metric",
  options: [],
};

export const ResponseSelectionSchema = {
  id: 6,
  name: "MultiSelect",
  type: "multiselect",
  title: "Related Response Data",
  required: false,
  placeholder: "Select response data",
  options: [],
};

export const fileInputSchema = {
  id: 1,
  name: "File Upload",
  type: "file",
  title: "Upload Evidence",
  required: true,
  acceptfieldtype: [
    "image/*",
    "audio/*",
    "video/*",
    "application/pdf",
    "application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ],
};

export const initialData = {
  "Upload Evidence": "",
  Description: "",
  Name: "",
  Category: "",
  "Related Metric": "",
  "Related Response Data": [],
};
